<template>
  <div class="container">
    <loading v-model:active="isLoading" />
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content">
                <h1 class="tm5 modal-title d-inline-block">
                  Choose Your {{ cardName }}
                </h1>
                <h4 v-if="cardName == 'ship'">
                  Allowed Ships: {{ selectedLocation.allowed_ships.join(", ") }}
                </h4>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >
                <div class="modal-body mdScroll px-5 pb-5">
                  <p v-if="error">{{ error }}</p>
                  <div class="text-center">
                    <div class="row no-gutters" v-if="!isLoading">
                      <div
                        class="col-md-4 mb-3"
                        v-for="(item, index) in info"
                        :key="index"
                      >
                        <div
                          class="card"
                          :class="item.selected ? 'selected' : ''"
                        >
                          <div class="card-body p-0">
                            <div class="card-img">
                              <img
                                class="card-img-top"
                                v-show="isImageLoaded"
                                :src="getImgUrl(item.data.img)"
                                alt=""
                                @click.prevent="addCard(item)"
                                @click="isSelected = !isSelected"
                                @load="loaded"
                              />
                              <img
                                v-if="!isImageLoaded"
                                class="card-img-top"
                                :src="'/lostsailor/images/loader.gif'"
                              />
                            </div>
                            <div class="progress-wrapper mgt-5">
                              <div class="progress-cont">
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 0"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 10"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 20"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 30"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 40"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 50"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 60"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 70"
                                ></div>
                                <div
                                  class="progress__bar"
                                  :class="item.useleft > 70 ? 'bg-danger' : ''"
                                  v-if="item.useleft > 80"
                                ></div>
                                <div
                                  class="progress__bar text-danger"
                                  v-if="item.useleft > 90"
                                ></div>
                              </div>
                            </div>
                            <span v-if="item.data.totaluse">{{
                              item.data.use + "/" + item.data.totaluse
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="btn btn-primary"
                    @click.prevent="hideModal()"
                  >
                    Select
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapGetters } from "vuex";
export default {
  name: "Modal",
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      "selectedCaptain",
      "selectedShip",
      "selectedFoods",
      "selectedSupply",
    ]),
  },
  props: [
    "error",
    "cards",
    "cardName",
    "foods",
    "supplies",
    "req_food",
    "selectedLocation",
  ],
  showModal: true,
  data() {
    return {
      info: null,
      isLoading: false,
      isImageLoaded: false,
      apiRes: null,
      isSelected: false,
    };
  },
  mounted() {
    // this.info = this.cards.filter(el => el.schema.schema_name == `${this.cardName}s`);
    if (this.cardName == "captain") {
      this.init(`captains`);
    } else if (this.cardName == "ship") {
      this.init(`ships`);
    } else if (this.cardName == "food") {
      this.init(`foods`);
    } else if (this.cardName == "supplies") {
      this.init(`supplies`);
    }
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    loaded() {
      this.isImageLoaded = true;
    },
    getImgUrl(hash) {
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=500";
    },
    addCard(item) {
      if (item.schema.schema_name == "foods") {
        let obj = this.selectedFoods.find(
          (data) => data.asset_id === item.asset_id
        );
        if (obj !== undefined) {
          toast.error("Card already selected, try another");
          return;
        }
      }
      this.info = this.info.map((row, index) => {
        if (item.asset_id == row.asset_id) {
          this.info[index].selected = true;
        } else {
          this.info[index].selected = false;
        }
        return row;
      });
      this.$store.commit("addCard", item);
      if (item.schema.schema_name == "foods") {
        if (this.selectedFoods.length == this.req_food)
          this.$emit("w-modal-hide-click");
      } else {
        this.$emit("w-modal-hide-click");
      }
    },
    filterResult(params) {
      if (params == "ships" && this.selectedCaptain) {
        this.info = this.apiRes.filter((el) => {
          var shipname = "";
          if (this.selectedCaptain.name == "Barbarossa") {
            shipname = "Fatih's Anger";
          } else if (this.selectedCaptain.name == "Blackbeard") {
            shipname = "Queen Anne's Revenge";
          } else if (this.selectedCaptain.name == "Magellan") {
            shipname = "Victoria";
          } else if (this.selectedCaptain.name == "Columbus") {
            shipname = "La Santa María";
          } else {
            this.info = this.apiRes;
          }
          return el.data.name == shipname;
        });
      } else if (params == "captains" && this.selectedShip) {
        this.info = this.apiRes.filter((el) => {
          var captain = "";
          if (this.selectedShip.name == "Fatih's Anger") {
            captain = "Barbarossa";
          } else if (this.selectedShip.name == "Queen Anne's Revenge") {
            captain = "Blackbeard";
          } else if (this.selectedShip.name == "Victoria") {
            captain = "Magellan";
          } else if (this.selectedShip.name == "La Santa María") {
            captain = "Columbus";
          } else {
            this.info = this.apiRes;
          }
          return el.data.name == captain;
        });
      } else {
        this.info = this.apiRes;
      }
    },
    init(params) {
      this.isLoading = true;
      ApiService.callApi(
        `collection_name=lostsailorsl&page=1&limit=100&schema_name=${params}`,
        async (response) => {
          let res = response["data"];
          if (res["success"]) {
            this.apiRes = res["data"];
            this.filterResult(params);
            if (params == "foods" || params == "supplies") {
              // this.isLoading = true;
              this.info.map(async (nft, i) => {
                if (nft.data.totaluse == 0) {
                  this.info[i].useleft = 0;
                } else {
                  this.info[i].useleft =
                    (nft.data.totaluse / nft.data.use) * 100;
                }
              });
            }
          } else {
            this.info = [];
          }
          this.isLoading = false;
        }
      );
    },
  },
};
</script>
<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  /* overflow-y: hidden; */
}
.modal-backdrop .modal-wrapper .modal-content .card {
  height: 308px !important;
}

.mdScroll {
  overflow-y: scroll;
  height: 413px;
}
.mdScroll::-webkit-scrollbar {
  width: 4px;
}

.mdScroll::-webkit-scrollbar-thumb {
  background: transparent;
  height: 2px !important;
  border-radius: 20px;
}

.mdScroll:hover::-webkit-scrollbar-thumb {
  background: #766640;
}

.mdScroll::-webkit-scrollbar-thumb:hover {
  background: #7b61ff;
}

.mdScroll::-webkit-scrollbar-thumb:hover {
  background: #555;
  border-right: none;
  border-left: none;
}

.mdScroll::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 22px;
}

.mdScroll::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 28px;
}

.close-modal {
  font-size: 28px;
  position: absolute;
  top: -20px;
  right: 20px;
  font-size: 60px;
  color: #e9c8a8;
}
.modal-wrapper .modal-content .modal-body .card {
  width: 100% !important;
  border: 1px solid #fff !important;
  margin-bottom: 20px;
}
.modal-wrapper .modal-content .modal-body .btn {
  background: #fff;
  color: black;
  border-radius: 27px;
  font-weight: bold;
  font-size: 2rem;
  width: 150px;
  margin: 10px auto;
}
.modal-wrapper .modal-content .card:hover {
  box-shadow: 10px 15px 20px rgba(209, 203, 203, 0.6);
  transform: translateY(-8px);
  transition: all 0.3;
}
.modal-wrapper .modal-content .card.selected {
  border: 2px solid red !important;
}
</style>
<style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}
.card {
  padding: 10px;
  background: transparent;
}
.card-img {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>